import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import "animate.css";
import TrackVisibility from "react-on-screen";
import colorSharp from "../assets/img/color-sharp.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import prodjectCategory from "../helpers/ProjectCategory";
import "../css/Projects.css";

export const Projects = () => {
  return (
    <section className="skill" id="project" >
      <div className="container" style={{ marginTop: "70px" }}>
        <div className="col-12">
          <div className="projects-bx wow zoomIn">
            
            <div className="about-section-projects">
              <h1 className="background-text">PROJECTS</h1>
              <h1
                className="foreground-text"
                style={{ color: "purple", fontWeight: "800" }}
              >
                PROJECTS
                <div
                  className="underline"
                  style={{ backgroundColor: "purple" }}
                ></div>
              </h1>
            </div>
            <Container style={{    marginTop: "50px"}}>

                <Col size={12} >
                  <TrackVisibility>
                    {({ isVisible }) => (
                      <div
                        className={
                          isVisible ? "animate__animated animate__fadeIn" : ""
                        }
                      >
                        <Tab.Container
                          id="projects-tabs"
                          defaultActiveKey={prodjectCategory[0].value}
                        >
                          <div className="projects-full-div" style={{gap:"30px"}}>
                            <div className="projects-cat-nav">
                              <Nav
                                variant="pills"
                                id="pills-tab"
                                className="project-category-grid"
                                // style={{ backgroundColor: "blue",display:"flex",flexDirection:"column",width:"200px" }}
                              >
                                {prodjectCategory.map((category) => (
                                  <Nav.Item key={category.id} style={{ width:"100%"}}>
                                    <Nav.Link eventKey={category.value}>
                                      {category.label}
                                    </Nav.Link>
                                  </Nav.Item>
                                ))}
                              </Nav>
                            </div>
                            <p style={{color:"blueviolet",fontWeight:"700"}}>* Click the project to view the full description.</p>
                            <div>
                              <Tab.Content
                                id="slideInUp"
                                className={
                                  isVisible
                                    ? "animate__animated animate__slideInUp"
                                    : ""
                                }
                              >
                                {prodjectCategory.map((category) => (
                                  <Tab.Pane
                                    eventKey={category.value}
                                    key={category.id}

                                  >
                                      <div className="projects-card-view">
                                        <ProjectCard category={category.value} />
                                      </div>


                                  </Tab.Pane>
                                ))}
                              </Tab.Content>
                            </div>
                          </div>

                        </Tab.Container>
                      </div>
                    )}
                  </TrackVisibility>
                </Col>
            </Container>
          </div>
        </div>
      </div>
      <img className="background-image-left-project" src={colorSharp} alt="Image" style={{zIndex:"-1"}}/>
      <img className="background-image-right-project" src={colorSharp2} alt="Image" />
    </section>
  );
};
